export default __webpack_public_path__ + "static/media/rigetti-chip.d83b437b.png";